export default __webpack_public_path__ + "static/media/logo2.4a0b55ec.png";